import React from 'react'

const GetStartedComponent = () => {
  return (
    <section className="bg-200" id="cta">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <h2 className="fw-bold text-black">Ready to get started?</h2>
            {/* <p>Get an guided demo with an OKR expert.</p> */}
          </div>
          <form className="col-lg-6 h-100" action="/user/register" method="get">
            <div className="input-group">
              <input className="form-control" type="text" placeholder="Email Address" name="email" />
              <input className="btn joystick-btn rounded-start-0 px-3" type="submit" value="Get Started"/>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}

export default GetStartedComponent